import { CustomFieldDefinitionDataTypeModel, CustomFieldDefinitionEntityTypeModel } from 'src/graphql/types';
import { beautifyName } from 'src/utils/textUtil';

const mappedEntityTypesEnum = Object.values(CustomFieldDefinitionEntityTypeModel).filter(
  (type) => type !== CustomFieldDefinitionEntityTypeModel.CustomObject
);
export const entityTypesOptions = mappedEntityTypesEnum.map((type) => ({ value: type, label: beautifyName(type) }));

export const supportedCalculatedFieldDataTypes: CustomFieldDefinitionDataTypeModel[] = [
  CustomFieldDefinitionDataTypeModel.Integer,
  CustomFieldDefinitionDataTypeModel.String
];

export const booleanOptions = [
  { label: 'True', value: true },
  { label: 'False', value: false }
];

const mappedDataTypes = Object.values(CustomFieldDefinitionDataTypeModel);

export const customFieldDataTypeOptions: { value: CustomFieldDefinitionDataTypeModel; label: string }[] =
  mappedDataTypes.map((type) => ({
    label: type,
    value: type
  })) ?? [];

export enum CustomFieldFormDataTest {
  Name = 'cf-name',
  ParentEntityType = 'cf-parent-entity-type',
  Code = 'cf-code',
  HelperText = 'cf-helperText',
  Group = 'cf-group',
  Type = 'cf-type',
  Values = 'cf-values',
  ObjectType = 'cf-object-type',
  MultiValued = 'cf-multi-valued',
  Calculated = 'cf-calculated-fields',
  FinancialField = 'cf-financial-field',
  CostCenters = 'cf-cost-centers',
  CostCentersList = 'cf-cost-centers-list',
  CostCentersFilter = 'cf-cost-centers-filter',
  SingleMode = 'cf-cost-centers-single-mode',
  TextMode = 'cf-cost-centers-text-mode'
}
